import { CustomApplicationState } from "@MasterBluePrint/Store/CustomApplicationState";

// Root selector: get the whole slice

// Selector: get dictionary entry by id
export default function getProductInfoListStatus(
    state: CustomApplicationState,
    id: string
): { isRealTimePricingLoaded: boolean; isRealTimeInventoryLoaded: boolean } | undefined
 {
    return state.customProductInfoListStatusState.productInfoListStatusById[id];
}